// File: client/src/config/brand.js
// Central brand config for FemaleUTI.com.
// The user will fill in TBD fields (phone, GA/FB pixel IDs, exact price) before launch.

const BRAND_CONFIG = {
  // Core brand
  name: 'FemaleUTI',
  tagline: 'Fast, Private UTI Treatment for Women',
  description:
    'Online UTI consultation for women. US-licensed doctors. Antibiotic prescription sent to your pharmacy in 30 minutes to 4 hours.',
  domain: 'femaleuti.com',
  url: 'https://femaleuti.com',

  // Legal entity (shared with ChatWithDr — same medical group)
  company: {
    name: 'Public Health Solution LLC',
    registration: 'Virginia, USA'
  },

  // Contact — shared lines with ChatWithDr medical group
  contact: {
    // General inquiries — 24/7 text line
    phoneGeneral: '(919) 588-CHAT',
    phoneGeneralDigits: '+19195882428',
    phoneGeneralPurpose: 'Text 24/7 · General Inquiries',

    // Case status — text after booking for updates on an active case
    phoneCase: '(540) 701-7011',
    phoneCaseDigits: '+15407017011',
    phoneCasePurpose: 'Text for Case Status · After Booking',

    supportEmail: 'support@femaleuti.com',

    address: {
      street: '2003 Plank Road #1283',
      city: 'Fredericksburg',
      state: 'VA',
      zip: '22401',
      country: 'USA'
    }
  },

  // Service & pricing
  services: {
    consultationPrice: process.env.REACT_APP_UTI_PRICE || '$34.99',
    responseTime: '30 minutes – 4 hours',
    serviceId: 'uti_women',
    serviceTitle: 'UTI Consultation (Women)',
    features: [
      'Women-focused care',
      'US-licensed physicians',
      'HIPAA compliant',
      'Prescription sent to your pharmacy',
      'No insurance needed'
    ]
  },

  // Analytics (fill via env vars before launch)
  analytics: {
    googleAnalytics: process.env.REACT_APP_GA_ID || null,
    googleTagManager: process.env.REACT_APP_GTM_ID || null,
    facebookPixel: process.env.REACT_APP_FB_PIXEL || null,
    tiktokPixel: process.env.REACT_APP_TIKTOK_PIXEL || null
  },

  // Legal
  legal: {
    privacyPolicy: '/privacy',
    termsOfService: '/terms',
    hipaaCompliance: true
  },

  // Multi-brand tagging (sent with every booking → Mongo → admin panel filter)
  source_site: 'femaleuti',

  // Pink palette (mirrors Tailwind primary.* tokens)
  theme: {
    primary: '#ec4899',
    secondary: '#db2777',
    accent: '#f472b6',
    deep: '#be185d',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444'
  }
};

export default BRAND_CONFIG;
